module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_8019.0477d096.png";